module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "fed-os"
  }, [_c('h1', [_vm._v("Front End Outsourcing")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("\n\t\t\tWhile you focus on your core business process, our expert web developers will maximize your ability to deliver high quality product and speed up time-to-market.\n\t\t")]), _vm._v(" "), _c('h3', {
    staticClass: "collapse-link",
    on: {
      "click": function($event) {
        _vm.toggleCollapse('collapseA')
      }
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapseA),
      expression: "!collapseA"
    }],
    staticClass: "glyphicon glyphicon-chevron-right"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapseA),
      expression: "collapseA"
    }],
    staticClass: "glyphicon glyphicon-chevron-down"
  }), _vm._v("\n\t\t\tWhy outsource your web development\n\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapseA),
      expression: "collapseA"
    }],
    staticClass: "collapse-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "spacing10"
  }), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\tOutsourcing web development makes a lot of sense in order to maximize your profits in a small amount of time.\n\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "spacing30"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "media-list icon-list"
  }, [_c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-euro"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Cost Savings.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-hourglass"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Time Savings.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-resize-horizontal"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Flexibility.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-record"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Focused Strategy.")])])]), _vm._v(" "), _c('li', {
    staticClass: "media media-success media-default"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('a', {
    staticClass: "btn btn-success btn-lg btn-circle"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h4', {
    staticClass: "media-heading"
  }, [_vm._v("Lack of in house experience.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a72c53b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/front-end-outsourcing/front-end-outsourcing.vue
// module id = 56
// module chunks = 1